import { defineStore } from 'pinia';
import { computed, reactive } from 'vue';
import { useConfigurationStore } from './configuration';

export interface ClientInfo {
    slug: string;
    displayName: string;
    walletVerificationRequired: boolean;
    myBtcRedirectsNewTab: boolean;
    usesEstimatedQuotes: boolean;
    canReturnUrlBeOpenedInBrowser: boolean;
    appendOrderInfoToReturnUrl: boolean;
}

export const useClientInfoStore = defineStore('client-info', () => {
    const configurationStore = useConfigurationStore();

    const client = reactive<ClientInfo>({
        slug: null,
        displayName: null,
        walletVerificationRequired: false,
        myBtcRedirectsNewTab: false,
        usesEstimatedQuotes: false,
        canReturnUrlBeOpenedInBrowser: false,
        appendOrderInfoToReturnUrl: false
    });

    function setClientInfo(clientInfo: ClientInfo): void {
        if (!clientInfo) {
            client.slug = null;
            client.displayName = null;
            client.walletVerificationRequired = false;
            client.myBtcRedirectsNewTab = false;
            client.usesEstimatedQuotes = false;
            client.canReturnUrlBeOpenedInBrowser = false;
            client.appendOrderInfoToReturnUrl = false;
            return;
        }

        client.slug = clientInfo.slug;
        client.displayName = clientInfo.displayName;
        client.myBtcRedirectsNewTab = clientInfo.myBtcRedirectsNewTab;
        client.usesEstimatedQuotes = clientInfo.usesEstimatedQuotes;
        client.canReturnUrlBeOpenedInBrowser = clientInfo.canReturnUrlBeOpenedInBrowser;
        client.appendOrderInfoToReturnUrl = clientInfo.appendOrderInfoToReturnUrl;

        // Wallet verification (and manual wallet address input) is only allowed when wallet confirmation is not required
        client.walletVerificationRequired = !configurationStore.instanceConfiguration.walletConfirmationRequired && clientInfo.walletVerificationRequired;
    }

    return {
        client: computed<ClientInfo>(() => client),
        setClientInfo
    };
});
